import create from 'zustand';

export type AudioVisualizerPosition = 'CENTER' | 'BOTTOM' | 'HIDDEN';

export interface AudioVisualizerStoreType {
  position: AudioVisualizerPosition;
  setPosition: (position: AudioVisualizerPosition) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const useAudioVisualizerStore = create<AudioVisualizerStoreType>(
  set => ({
    position: 'HIDDEN',
    setPosition: position => set({ position }),
    visible: false,
    setVisible: visible => set({ visible }),
  })
);
